import React from "react";
import { useTranslation } from "react-i18next";
import { IsCreditRatingSDM } from "@Constants/tokens";
import GreenButton from "@View/components/buttons/GreenButton";

const Scoring = ({ onClick }) => {
  const { t } = useTranslation();
  const label = IsCreditRatingSDM() ? t("ScoringRKK") : t("Scoring");

  return (
    <GreenButton onClick={onClick} style={{ marginRight: "10px" }}>
      {label}
    </GreenButton>
  );
};

export default Scoring;
